import { PlayerWrapper } from "@infinitaslearning/app-player";
import type React from "react";

const defaultPlayerConfig = { retryConfig: {} };

export interface PlayerProps {
  id: string;
  // biome-ignore lint/suspicious/noExplicitAny: PlayerWrapper accepts dynamic content structure
  data?: any;
  // biome-ignore lint/suspicious/noExplicitAny: PlayerWrapper accepts dynamic config structure
  config?: any;
}

export const Player: React.FC<PlayerProps> = ({ id, data, config = defaultPlayerConfig }) => {
  return <PlayerWrapper id={id} config={config} initialData={data} />;
};
